<div fxLayout="column" fxLayoutGap="1em">
  <header>
    <div>
      <button mat-button color="basic">
        <span class="main-title" (click)="goBack()">
          <span class="material-icons">keyboard_arrow_left</span>User Settings
        </span>
      </button>
    </div>
  </header>
  <div *ngIf="userInfo">
    <p class="panel-title">User Information</p>
    <form [formGroup]="accountForm" (ngSubmit)="saveAccountData()">
      <div fxLayout="row" fxLayoutGap="1em">
        <div fxFlex="33">
          <mat-form-field
            appearance="outline"
            floatLabel="never"
            class="input-theme"
          >
            <mat-label>First Name</mat-label>
            <input
              matInput
              placeholder="First Name"
              name="name"
              formControlName="name"
              autocomplete="off"
            />
          </mat-form-field>
        </div>
        <div fxFlex="33">
          <mat-form-field
            appearance="outline"
            floatLabel="never"
            class="input-theme"
          >
            <mat-label>Last Name</mat-label>
            <input
              matInput
              placeholder="last Name"
              name="last"
              formControlName="last"
              autocomplete="off"
            />
          </mat-form-field>
        </div>
        <div fxFlex="33">
          <mat-form-field
            appearance="outline"
            floatLabel="never"
            class="input-theme"
          >
            <mat-label>Profile Picture</mat-label>
            <ngx-mat-file-input
              formControlName="image"
              placeholder="Pick a picture"
              accept="image/*"
            >
            </ngx-mat-file-input>
            <mat-icon matSuffix>add_a_photo</mat-icon>
          </mat-form-field>
        </div>
      </div>
      <div class="set-password" fxLayout="row" fxLayoutAlign="end center">
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="accountForm.invalid"
        >
          Save Changes
        </button>
      </div>
    </form>
  </div>
  <div>
    <p class="panel-title">Change Password</p>
    <form
      [formGroup]="passwordForm"
      (ngSubmit)="changePassword(formDirective)"
      #formDirective="ngForm"
    >
      <div fxLayout="row" fxLayoutGap="1em">
        <div fxFlex="33">
          <mat-form-field
            appearance="outline"
            floatLabel="never"
            class="input-theme"
          >
            <mat-label>Old Password</mat-label>
            <input
              matInput
              placeholder="Old Password"
              formControlName="old_pass"
              type="password"
              autocomplete="off"
            />
          </mat-form-field>
        </div>
        <div fxFlex="33">
          <mat-form-field
            appearance="outline"
            floatLabel="never"
            class="input-theme"
          >
            <mat-label>New Password</mat-label>
            <input
              matInput
              placeholder="New Password"
              formControlName="new_pass"
              type="password"
              autocomplete="off"
            />
          </mat-form-field>
        </div>
        <div fxFlex="33">
          <mat-form-field
            appearance="outline"
            floatLabel="never"
            class="input-theme"
          >
            <mat-label>Confirm new Password</mat-label>
            <input
              matInput
              placeholder="Confirm new Password"
              formControlName="con_pass"
              type="password"
              autocomplete="off"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="set-password" fxLayout="row" fxLayoutAlign="end center">
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="passwordForm.invalid"
        >
          Save Changes
        </button>
      </div>
    </form>
  </div>
</div>
